export { default } from 'shared/components/image'
